import { getAPIN8N } from "@/services/Api/n8nApiConfig";

export function useGetTaxBrands() {
  const getTaxForBrands = ({ amount }: { amount: number | string }) => {
    
    const baseUrl = `/v1/payment-links/installments-payment?amount=${amount}`;
    
    return getAPIN8N().get(baseUrl);
  };

  return { getTaxForBrands };
}